<template>
  <base-layout>
    <div class="page-content">
      <v-row>
        <v-col cols="12">
          <h1 class="title font-weight-bold">
            รายการสินค้า
          </h1>
        </v-col>
      </v-row>
      <orderItems
        :items="items"
        @onClearCart="activeModal = true"
        @onRemoveItem="removeItem" />
      <v-row class="order-summary">
        <v-col cols="12">
          <h1 class="title font-weight-bold">
            สรุปคำสั่งซื้อ
          </h1>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="6">
              <label class="pl-4 pt-2 d-block">
                ค่าจัดส่ง
              </label>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="shippingPrice"
                single-line
                type="number"
                dense
                placeholder="ค่าจัดส่ง"
                outlined
                suffix="บาท"
                @input="setShippingPrice" />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <div
                class="pr-10 pl-4">
                <v-select
                  v-model="discountType"
                  :items="selectItem"
                  dense
                  outlined
                  @input="setDiscount" />
              </div>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="discountNumber"
                single-line
                placeholder="ส่วนลด"
                dense
                outlined
                :suffix="discountType"
                @input="setDiscount" />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">
              <label class="pl-4 pt-2 d-block font-weight-bold">
                ยอดสุทธิ
              </label>
            </v-col>
            <v-col cols="8">
              <label class="pl-4 pt-2 d-block text-right font-weight-bold">
                {{ net | showFullPriceFormat() }} บาท
              </label>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="order-customer">
        <v-col cols="12">
          <h1 class="title font-weight-bold">
            ข้อมูลลูกค้า
          </h1>
        </v-col>
        <v-col cols="12">
          <v-form
            ref="form"
            v-model="validShipping">
            <v-row no-gutters>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ชื่อและนามสกุล
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerName"
                  :rules="[v => !!v || 'กรุณากรอก ชื่อและนามสกุล']"
                  single-line
                  dense
                  outlined
                  @input="setShipping" />
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  เบอร์ติดต่อ
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerTel"
                  :rules="[v => !!v || 'กรุณากรอก เบอร์ติดต่อ']"
                  single-line
                  dense
                  outlined
                  type="number"
                  @input="setShipping" />
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ที่อยู่
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerAddress"
                  :rules="[v => !!v || 'กรุณากรอก ที่อยู่']"
                  single-line
                  dense
                  outlined
                  @input="setShipping" />
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  ตำบล / แขวง
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerSubDistrict"
                  :rules="[v => !!v || 'กรุณากรอก ตำบล / แขวง']"
                  single-line
                  dense
                  outlined
                  @input="setShipping" />
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  อำเภอ / เขต
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerDistrictCity"
                  :rules="[v => !!v || 'กรุณากรอก อำเภอ / เขต']"
                  single-line
                  dense
                  outlined
                  @input="setShipping" />
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  จังหวัด
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerStateProvince"
                  :rules="[v => !!v || 'กรุณากรอก จังหวัด']"
                  single-line
                  dense
                  outlined
                  @input="setShipping" />
              </v-col>
              <v-col cols="4">
                <label class="pl-4 pt-2 d-block">
                  รหัสไปรษณีย์
                </label>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="customerPostcode"
                  :rules="[
                    v => !!v || 'กรุณากรอก รหัสไปรษณีย์',
                  ]"
                  single-line
                  dense
                  type="number"
                  outlined
                  @input="setShipping" />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </div>
    <div
      class="add-new-item"
      style="justify-content: center; display: flex; flex-wrap: wrap;">
      <v-col
        v-if="!isEditBill"
        class="text-center">
        <v-btn @click="$router.go(-1)">
          กลับ
        </v-btn>
      </v-col>
      <v-col
        v-if="isEditBill"
        class="text-center">
        <v-btn @click="$router.push({ name: 'Product' })">
          เพิ่มสินค้า
        </v-btn>
      </v-col>
      <v-col
        v-if="!isEditBill"
        class="text-center">
        <v-btn
          color="info"
          @click="createOrder()">
          สร้างออเดอร์
        </v-btn>
      </v-col>
      <v-col
        v-if="isEditBill"
        class="text-center">
        <v-btn
          color="info"
          @click="updateOrder()">
          บันทึก
        </v-btn>
      </v-col>
      <v-col
        v-if="isEditBill"
        class="text-center">
        <v-btn
          color="error"
          @click="cancelEditBill">
          ยกเลิก
        </v-btn>
      </v-col>
    </div>
    <modalConfirm
      confirm-text="Clear"
      cancel-text="Cancel"
      title="Clear all items?"
      :active="activeModal"
      @update:active="activeModal = $event"
      @onConfirm="clearItems()"
    />
  </base-layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import modalConfirm from '@/components/modal-confirm.vue'
import orderItems from '../components/order-items.vue'

export default {
  components: {
    orderItems,
    modalConfirm
  },
  data () {
    return {
      shippingPrice: 0,
      discountNumber: 0,
      activeModal: false,
      discountType: 'บาท',
      validShipping: true,
      selectItem: ['%', 'บาท'],
      customerName: '',
      customerEmail: '',
      customerTel: '',
      customerAddress: '',
      customerSubDistrict: '',
      customerDistrictCity: '',
      customerStateProvince: '',
      customerCountry: '',
      customerPostcode: ''
    }
  },
  computed: {
    ...mapGetters({
      discount: 'Order/discount',
      orderShippingPrice: 'Order/shippingPrice',
      net: 'Order/net',
      shipping: 'Order/shipping',
      bill: 'Order/bill',
      items: 'Order/items',
      isEditBill: 'Order/isEditBill',
      editingBill: 'Order/editingBill'
    })
  },
  mounted () {
    this.shippingPrice = this.orderShippingPrice
    this.discountNumber = this.discount.number
    this.discountType = this.discount.type
    this.customerName = this.shipping.customerName
    this.customerEmail = this.shipping.customerEmail
    this.customerTel = this.shipping.customerTel
    this.customerAddress = this.shipping.customerAddress
    this.customerSubDistrict = this.shipping.customerSubDistrict
    this.customerDistrictCity = this.shipping.customerDistrictCity
    this.customerStateProvince = this.shipping.customerStateProvince
    this.customerCountry = this.shipping.customerCountry
    this.customerPostcode = this.shipping.customerPostcode
  },
  methods: {
    ...mapActions({
      clearItems: 'Order/clearItems',
      clearCart: 'Order/clearCart',
      removeItem: 'Order/removeItem',
      setOrderShippingPrice: 'Order/setShippingPrice',
      setOrderDiscount: 'Order/setDiscount',
      setOrderShipping: 'Order/setShipping',
      createOrderOrder: 'Order/createOrder',
      updateOrderOrder: 'Order/updateOrder',
      setSnackBar: 'Style/setSnackbar',
      setLoading: 'Style/setLoading'
    }),
    validate () {
      this.$refs.form.validate()
    },
    cancelEditBill () {
      this.clearCart()
      this.$router.push({ name: 'Order' })
    },
    setShippingPrice () {
      if (this.shippingPrice !== '') {
        this.setOrderShippingPrice(parseFloat(this.shippingPrice))
      } else {
        this.setOrderShippingPrice(0)
      }
    },
    async updateOrder () {
      if (this.items.length === 0) {
        this.setSnackBar({
          value: true,
          message: 'กรุณาเลือกสินค้าที่ต้องการสร้าง Order',
          type: 'error'
        })
        return
      }
      const billId = this.editingBill.id
      const warehouse = [...new Set(this.items.map((item) => item.warehouse))]
      if (warehouse.length > 1) {
        this.setSnackBar({
          value: true,
          message: 'กรุณาเลือกสินค้าใน Store เดียวกัน',
          type: 'error'
        })
        return
      }
      if (this.editingBill.concatWarehouse !== warehouse[0]) {
        this.setSnackBar({
          value: true,
          message: `บิลนี้เลือกสินค้าเฉพาะ สาขา ${this.editingBill.concatWarehouse} เท่านั้น`,
          type: 'error'
        })
        return
      }
      this.validate()
      if (this.validShipping) {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'Updating order.'
        })
        const result = await this.updateOrderOrder(warehouse[0])
        this.setLoading({
          active: false,
          clickAble: false,
          message: ''
        })
        if (result.success) {
          this.setSnackBar({
            value: true,
            message: 'อัพเดท Order สำเร็จ',
            type: 'success'
          })
          this.$router.push({ name: 'OrderCreated', params: { id: billId } })
        } else {
          this.setSnackBar({
            value: true,
            message: result.message ? result.message : 'เกิดข้อผิดพลาดจาก Server กรุณาลองใหม่',
            type: 'error'
          })
        }
      } else {
        this.setSnackBar({
          value: true,
          message: 'กรูณากรอกข้อมูลจัดส่งให้ครบ',
          type: 'error'
        })
      }
    },
    async createOrder () {
      if (this.items.length === 0) {
        this.setSnackBar({
          value: true,
          message: 'กรุณาเลือกสินค้าที่ต้องการสร้าง Order',
          type: 'error'
        })
        return
      }

      const warehouse = [...new Set(this.items.map((item) => item.warehouse))]
      if (warehouse.length > 1) {
        this.setSnackBar({
          value: true,
          message: 'กรุณาเลือกสินค้าใน Store เดียวกัน',
          type: 'error'
        })
        return
      }

      this.validate()
      if (this.validShipping) {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'Creating order.'
        })
        const result = await this.createOrderOrder(warehouse[0])
        this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting Products.'
        })
        if (result.success) {
          this.setSnackBar({
            value: true,
            message: 'สร้าง Order สำเร็จ',
            type: 'success'
          })
          this.$router.push({ name: 'OrderCreated', params: { id: this.bill.id } })
        } else {
          this.setSnackBar({
            value: true,
            message: result.message ? result.message : 'เกิดข้อผิดพลาดจาก Server กรุณาลองใหม่',
            type: 'error'
          })
        }
      } else {
        this.setSnackBar({
          value: true,
          message: 'กรูณากรอกข้อมูลจัดส่งให้ครบ',
          type: 'error'
        })
      }
    },
    setShipping () {
      this.setOrderShipping({
        customerName: this.customerName,
        customerEmail: this.customerEmail,
        customerTel: this.customerTel,
        customerAddress: this.customerAddress,
        customerSubDistrict: this.customerSubDistrict,
        customerDistrictCity: this.customerDistrictCity,
        customerStateProvince: this.customerStateProvince,
        customerCountry: this.customerCountry,
        customerPostcode: this.customerPostcode
      })
    },
    setDiscount () {
      if (this.discountNumber !== '') {
        this.setOrderDiscount({
          type: this.discountType,
          number: parseFloat(this.discountNumber)
        })
      } else {
        this.setOrderDiscount({
          type: this.discountType,
          number: 0
        })
      }
    }
  }
}
</script>

<style scoped>
.sku-variant.d-flex> p:first-child {
  min-width: 75px;
  margin-right: 10px;
}
.cart-single-item {
  position: relative;
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 16px;
}
.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.order-summary,
.order-customer {
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 16px;
  margin-bottom: 16px;
}
.page-content {
  overflow-y: auto;
  height: calc(100vh - 130px);
}
@media screen and (min-width: 768px) {
  .page-content::-webkit-scrollbar {
    display: none;
  }
}
button.remove-btn {
  position: absolute;
  bottom: 30px;
  right: 30px;
  transition: all 0.1s;
}
button.remove-btn:active {
  transform: scale(1.2);
}
</style>
